import React, { useEffect, useState, useRef } from "react";
import { SearchOutlined } from "@ant-design/icons";
import Highlighter from "react-highlight-words";
import { BASE_URL, BASE_IMAGE_URL } from "../../service/apiConfig";
import {
  Select,
  Typography,
  Space,
  Button,
  Table,
  Modal,
  Form,
  Input,
  notification,
  Upload,
  message,
  Card,
  DatePicker,
  Row,
  Col,
} from "antd";
import { LoadingOutlined, PlusOutlined } from "@ant-design/icons";
import bannerServiceApi from "../../service/bannerService";
import {
  EditorState,
  ContentState,
  convertFromHTML,
} from "draft-js";
import "./management.css";
import isEqual from 'lodash/isEqual';

export default function ManagementPage() {
  const [bannerId, setBannerId] = useState(0);

  const [isShowUpdateService, setIsShowUpdateService] = useState(false);

  const [listBannerService, setListBannerService] = useState([]);

  const [fileListService, setFileListService] = useState([]);
  const [fileListBannerSubmit, setFileListBannerSubmit] = useState([]);

  const [loading, setLoading] = useState(false);
  const [invalidImage, setInvalidImage] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);

  const [formBanner] = Form.useForm();
  
  const [dataChange, setDataChange] = useState(true);

  useEffect(() => {
    getAllBanners();
  }, []);

  const onFormValueChange = () =>{
    setDataChange(true)
  }

  const getAllBanners = () => {
    bannerServiceApi.getAll().then((res) => {
      setListBannerService(res.data);
    });
  };

  const deleteBanner = () => {
    bannerServiceApi.deleteBannerById(bannerId).then((res) => {
      notification.success({ message: `Xóa Thành Công` });
      getAllBanners();
      setOpenDeleteDialog(false);
      setBannerId(0);
    });
  };

  const openModalService = (id) => {
    setBannerId(id);
    if (id) {
      bannerServiceApi.getById(id).then((res) => {
        setFileListService([{ url: BASE_IMAGE_URL + res.data.picture }]);
        setFileListBannerSubmit([res.data.picture]);
        formBanner.setFieldsValue({
          title: res.data.title,
          url: res.data.url,
        });
        setIsShowUpdateService(true);
      });
    }
  };

  const onCloseModalEvent = () => {
    setIsShowUpdateService(false);
    setFileListService([]);
    setFileListBannerSubmit([]);
    formBanner.setFieldsValue({
      title: "",
      url: "",
      picture: "",
    });
  };

  const layout = {
    labelCol: { span: 5 },
    wrapperCol: { span: 20 },
  };

  const openDeleteService = (id) => {
    setBannerId(id);
    setOpenDeleteDialog(true);
  };
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = useRef(null);

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div
        style={{
          padding: 8,
        }}
      >
        <Input
          ref={searchInput}
          placeholder={`Tìm kiếm ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: "block",
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            Search
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{
              width: 90,
            }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({
                closeDropdown: false,
              });
              setSearchText(selectedKeys[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            Filter
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? "#1890ff" : undefined,
        }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex]?.toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: "#ffc069",
            padding: 0,
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text?.toString() : ""}
        />
      ) : (
        text
      ),
  });

  const columnsService = [
    {
      title: "Picture",
      dataIndex: "picture",
      key: "picture",
      width: "180px",
      render: (value) => <img height={70} src={BASE_IMAGE_URL + value} alt={value} />
    },
    {
      title: "Tiêu Đề",
      dataIndex: "title",
      key: "title",
      ...getColumnSearchProps("title"),
    },
    {
      title: "URL",
      dataIndex: "url",
      key: "url",
      ...getColumnSearchProps("url"),
    },
    {
      title: "Action",
      key: "action",
      width: "180px",
      render: (_, record) => (
        <Space size="middle">
          <Button
            type="primary"
            style={{
              borderRadius: 8,
            }}
            onClick={() => openModalService(_.id)}
          >
            Sửa
          </Button>
          <Button
            type="danger"
            style={{
              borderRadius: 8,
            }}
            onClick={() => openDeleteService(_.id)}
          >
            Xóa
          </Button>
        </Space>
      ),
    },
  ];

  const onFinishHandleEvent = (values) => {
    values.picture = typeof fileListBannerSubmit[0] != 'undefined' ? fileListBannerSubmit[0] : fileListBannerSubmit;
    if (bannerId !== 0) {
      bannerServiceApi.updateEvent(bannerId, values).then((res) => {
        notification.success({ message: "Sửa Banner Thành Công" });
        getAllBanners();
        onCloseModalEvent();
        setBannerId(0);
      });
    } else {
      bannerServiceApi.createEvent(values).then((res) => {
        notification.success({ message: "Tạo Banner Thành Công" });
        formBanner.setFieldsValue({
          title: "",
          url: "",
          picture: "",
        });
        getAllBanners();
        onCloseModalEvent();
      });
    }
  };

  const uploadButton = (
    <div>
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div
        style={{
          marginTop: 8,
        }}
      >
        Thêm Ảnh
      </div>
    </div>
  );

  const handleChangeService = async ({ fileList: newFileList }) => {
    if (!invalidImage) {
      setFileListService(newFileList);
      const urlArray = [];
      const urlArraySubmit = [];
      let checkTotal = 0;
      let check = 0;
      await newFileList.forEach((item) => {
        if (typeof item?.status !== "undefined") {
          checkTotal++;
          if (item.status === "uploading") {
            setLoading(true);
            return;
          }
          if (item.status === "done") {
            check++;
          }
        } else {
          urlArray.push(item);
          urlArraySubmit.push("/images/" + item.url.split("/images/")[1]);
        }
      });
      if (check === checkTotal) {
        newFileList.forEach((item) => {
          if (typeof item?.status !== "undefined") {
            const temp = { url: BASE_IMAGE_URL + item.response.data.url };
            urlArray.push(temp);
            urlArraySubmit.push(item.response.data.url);
          }
        });
      }

      setFileListBannerSubmit(urlArraySubmit);
      setLoading(false);
    }
  };

  const beforeUpload = (file) => {
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";

    if (!isJpgOrPng) {
      message.error("You can only upload JPG/PNG file!");
      setInvalidImage(true);
    } else {
      setInvalidImage(false);
    }

    return isJpgOrPng;
  };

  return (
    <>
      <Card
        title={
          <Typography style={{ textAlign: "center" }}>
            Banners
          </Typography>
        }
        extra={
          <Button
            type="primary"
            style={{
              borderRadius: "8px",
            }}
            onClick={() => {
              setIsShowUpdateService(true);
            }}
          >
            Tạo banner
          </Button>
        }
      >
        <Table
          columns={columnsService}
          dataSource={listBannerService}
          bordered
        />

        <Modal
          title={
            bannerId !== 0
              ? "Cập Nhật Banner"
              : "Tạo Banner"
          }
          visible={isShowUpdateService}
          width="70%"
          onCancel={() => {
            setBannerId(0);
            onCloseModalEvent();
            setFileListBannerSubmit([]);
          }}
          footer={[
            <>
              <Button
                size="small"
                onClick={() => {
                  onCloseModalEvent();
                }}
              >
                Đóng
              </Button>
              <Button
                size="small"
                className="btn btn-primary"
                type="primary"
                form="CU-tour"
                key="submit"
                htmlType="submit"
                disabled = {!dataChange}
              >
                Hoàn Thành
              </Button>
            </>,
          ]}
        >
          <Row justify="space-around">
            <Col span={24}>
              <Upload
                name="file"
                listType="picture-card"
                showUploadList={true}
                multiple={false}
                action={BASE_IMAGE_URL + "/api/upload"}
                beforeUpload={beforeUpload}
                onChange={handleChangeService}
                fileList={fileListService}
                maxCount={1}
              >
                {uploadButton}
              </Upload>
              <Form
                {...layout}
                form={formBanner}
                name="CU-tour"
                onFinish={onFinishHandleEvent}
                onValuesChange = {onFormValueChange}
              >
                <Form.Item name="title" label="Tiêu đề">
                  <Input size="large" />
                </Form.Item>
                <Form.Item name="url" label="URL">
                  <Input size="large" placeholder="http:// or https://" />
                </Form.Item>
              </Form>
            </Col>
          </Row>
        </Modal>
      </Card>
      <Modal
        visible={openDeleteDialog}
        onOk={deleteBanner}
        onCancel={() => {
          setBannerId(0);
          setOpenDeleteDialog(false);
        }}
        title={`Xóa banner`}
      >
        Bạn có chắc muốn xóa banner này?
      </Modal>
    </>
  );
}
